var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchBusNumber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search_Bus_Number",
    "data-name": "Search Bus Number",
    transform: "translate(-511 -557)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 72,
    height: 72,
    rx: 12,
    transform: "translate(511 557)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Search_Bus_Number_icon",
    "data-name": "Search Bus Number icon",
    transform: "translate(532.694 575.336)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 48,
    height: 48,
    transform: "translate(-9.694 -6.336)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    d: "M1.8,1.8v1.2H5.391V1.8H1.8M1.2,0H5.99a1.2,1.2,0,0,1,1.2,1.2v2.4a1.2,1.2,0,0,1-1.2,1.2H1.2A1.2,1.2,0,0,1,0,3.594V1.2A1.2,1.2,0,0,1,1.2,0Z",
    transform: "translate(2.036 32.871)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    d: "M1.8,1.8v1.2H5.391V1.8H1.8M1.2,0H5.99a1.2,1.2,0,0,1,1.2,1.2v2.4a1.2,1.2,0,0,1-1.2,1.2H1.2A1.2,1.2,0,0,1,0,3.594V1.2A1.2,1.2,0,0,1,1.2,0Z",
    transform: "translate(14.016 32.871)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_8",
    "data-name": "Subtraction 8",
    d: "M20.364,27.554H3.592A3.6,3.6,0,0,1,0,23.96V3.594A3.6,3.6,0,0,1,3.592,0h7.185a9.467,9.467,0,0,0-.6,1.8H3.592a1.8,1.8,0,0,0-1.8,1.8V16.771a1.8,1.8,0,0,0,1.8,1.8h18.57V12.886a9.475,9.475,0,0,0,1.8-.758V23.96A3.6,3.6,0,0,1,20.364,27.554ZM1.8,19.883h0V23.96a1.8,1.8,0,0,0,1.8,1.8H20.364a1.8,1.8,0,0,0,1.8-1.8v-3.6H3.592A3.585,3.585,0,0,1,1.8,19.883Z",
    transform: "translate(-0.359 6.515)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_7",
    "data-name": "Subtraction 7",
    d: "M1.8,9.272H0V0A9.374,9.374,0,0,0,1.8,1.915V9.271Z",
    transform: "translate(11.32 15.812)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 1.198,
    cy: 1.198,
    r: 1.198,
    transform: "translate(3.833 28.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_22_-_Outline",
    "data-name": "Ellipse 22 - Outline",
    d: "M1.2,0A1.2,1.2,0,1,1,0,1.2,1.2,1.2,0,0,1,1.2,0Z",
    transform: "translate(3.833 28.079)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 1.198,
    cy: 1.198,
    r: 1.198,
    transform: "translate(17.011 28.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_21_-_Outline",
    "data-name": "Ellipse 21 - Outline",
    d: "M1.2,0A1.2,1.2,0,1,1,0,1.2,1.2,1.2,0,0,1,1.2,0Z",
    transform: "translate(17.011 28.079)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    d: "M7.884,1.8A6.087,6.087,0,1,0,13.97,7.884,6.093,6.093,0,0,0,7.884,1.8m0-1.8A7.884,7.884,0,1,1,0,7.884,7.884,7.884,0,0,1,7.884,0Z",
    transform: "matrix(0.454, -0.891, 0.891, 0.454, 8.439, 13.814)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_29",
    "data-name": "Line 29",
    d: "M.9,7.787a.9.9,0,0,1-.9-.9V.9A.9.9,0,0,1,1.8.9v5.99A.9.9,0,0,1,.9,7.787Z",
    transform: "matrix(0.454, -0.891, 0.891, 0.454, 24.73, 14.167)",
    fill: "#006"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBusNumber);
export default __webpack_public_path__ + "static/media/SearchBusNumber.3c7c186ac0cb5263d58cc4a1ae04f197.svg";
export { ForwardRef as ReactComponent };